export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.7-1419.46",
  commitId: "c46e3f3e043c95d749466cab52319995fd989107",
  commitTime: "2026-07-07T14:19:46.000Z",
});
